import { Text } from '@chakra-ui/layout'
import moment from 'moment'
import React from 'react'
import { Flex } from '@chakra-ui/react'
import { APP_NAME, AUTHOR } from '../../constants'

type CopyrightProps = {}

const Copyright: React.FC<CopyrightProps> = () => {
  return (
    <Flex
      color="gray.500"
      w={{ base: '100%', md: 'fit-content' }}
      mt={[8, 0, 0]}
      fontSize="xs"
      align="center"
    >
      <Flex
        width="100%"
        direction="column"
        justify={['center', 'flex-start', 'flex-start']}
        align="flex-start"
      >
        <Text>
          Copyright © {moment().format('YYYY')} Designed by {AUTHOR} <br />
          All rights reserved. {APP_NAME}
        </Text>
      </Flex>
    </Flex>
  )
}

export default Copyright
